/**
 * ATNA Logging API Documentation
 * Rest API used to query log entries
 *
 * OpenAPI spec version: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Syslog } from './Syslog';

export class PaginatedListSyslog { 
    constructor(json: JSON | any) {
        Object.assign(this as PaginatedListSyslog, json)
    }

    pageSize?: number;
    totalSize?: number;
    rows?: Array<Syslog>;
    paginationBookmark?: string;
}

